export const environment = {
  production: false,
  API_URL: 'https://cars-web-api-staging.herokuapp.com/api/v2/'
};
